<section class="feature-page">
  <app-page-header title="Equivalencias NAC Portal" subtitle="Definí cómo importar los valores del Portal a Comunidades."></app-page-header>
  <div class="feature-page__content">
    <mat-card class="table-surface-card">
      <mat-card-content>
        <app-table-surface
          tableId="portal-import-equivalences"
          [columns]="columns"
          [data]="tableData"
          [isLoading]="loading"
          [errorMessage]="errorMessage"
          [cellTemplate]="cellTemplate"
          [enableSearch]="true"
          [enableSort]="true"
          [enableColumnVisibility]="true"
          [enableDensity]="true"
          [enableFilter]="true"
          [enableClearFilters]="true"
          [activeFilters]="activeFilterChips"
          [paginationConfig]="paginationConfig"
          [showPageSizeSelector]="true"
          [pageSizeOptions]="[10, 25, 50, 100]"
          [sortState]="sortState"
          [initialSort]="initialSort"
          [readonly]="loading || !!errorMessage"
          searchPlaceholder="Buscar equivalencias..."
          [noDataMessage]="searchTerm || activeFilterChips.length ? 'No se encontraron equivalencias con estos filtros.' : 'Todavía no hay equivalencias configuradas.'"
          primaryActionLabel="Nueva equivalencia"
          (primaryActionClick)="edit()"
          (searchChange)="onSearch($event)"
          (filterRemove)="onFilterRemove($event)"
          (clearFiltersClick)="clearFilters()"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (sortChange)="onSortChange($event)"
          (toolbarSortChange)="onSortChange($event)">
          <div filterPanel class="equivalence-filter-panel" [formGroup]="filterForm">
            <app-data-table-multi-select-filter formControlName="section" label="Sección" [options]="sectionOptions"></app-data-table-multi-select-filter>
            <app-data-table-multi-select-filter formControlName="destination" label="Destino" [options]="destinationOptions"></app-data-table-multi-select-filter>
            <app-data-table-multi-select-filter formControlName="unit" label="Unidad" [options]="unitOptions"></app-data-table-multi-select-filter>
          </div>
          <div toolbarActions *ngIf="errorMessage">
            <button mat-button (click)="load()"><mat-icon>refresh</mat-icon>Reintentar</button>
          </div>
          <ng-template #cellTemplate let-row="row" let-column="column">
            <div *ngIf="column === 'actions'; else value" class="table-actions">
              <button mat-icon-button type="button" matTooltip="Editar" [attr.aria-label]="'Editar equivalencia de ' + row.sourceValue"
                [disabled]="loading || deletingId === row.id" (click)="$event.stopPropagation(); edit(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button type="button" matTooltip="Eliminar" [attr.aria-label]="'Eliminar equivalencia de ' + row.sourceValue"
                [disabled]="loading || deletingId === row.id" (click)="$event.stopPropagation(); remove(row)">
                <mat-icon color="warn">delete</mat-icon>
              </button>
            </div>
            <ng-template #value>
              <div *ngIf="column === 'sourceValue' && row.sourceLabel; else plainValue" class="portal-source">
                <span>{{ row.sourceLabel }}</span>
                <span class="portal-source__reference">{{ row.sourceValue }}</span>
              </div>
              <ng-template #plainValue>{{ row[column] }}</ng-template>
            </ng-template>
          </ng-template>
        </app-table-surface>
      </mat-card-content>
    </mat-card>
  </div>
</section>
